<app-auto-complete-select [itemControl]="itemControl"
                          [getItemName]="getItemName"
                          [label]="label"
                          [search]="search"
                          [minCharacters]="minCharacters"
                          (selected)="onSelected($event)"
                          [errors]="error ? [error] : null">
</app-auto-complete-select>